'use client';

import { useEventListener, useIsomorphicLayoutEffect } from '@websolutespa/bom-mixer-hooks';
import { useState } from 'react';

let lastScrollTop: number = 0;

const DEFAULT_CALLBACK = (top: number, left: number) => {
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  let direction = 0;
  if (scrollTop > lastScrollTop) {
    direction = 1;
  } else if (scrollTop < lastScrollTop) {
    direction = -1;
  }
  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  return direction;
};

export function useScrollDirection(callback: (top: number, left: number) => number = DEFAULT_CALLBACK): number {
  const [direction, setDirection] = useState<number>(0);

  const onScrolled = () => {
    const direction_ = callback(window.scrollY, window.scrollX);
    if (direction !== direction_) {
      setDirection(direction_);
    }
  };

  useEventListener('scroll', onScrolled);

  // Set size at the first client-side load
  useIsomorphicLayoutEffect(() => {
    onScrolled();

  }, []);

  return direction;
}
